import React from "react";
import PotentialMetrices from "./PotentialMetrices";
import PromotionMetrices from "./PromotionMetrices";
import SuccessorComponent from "./Successor";
import EmployeeManagerDetail from "./EmployeeManagerDetail";
import { useState, useEffect,useRef } from "react";
import { employeesURL, successorURL } from "../Config";
import { useAppContext } from "./AppContext";


import { Form, Col, Row, Typography, Button, Space, message,Select } from "antd";
import { set } from "date-fns";

const { Text } = Typography;
const AssessmentPage = ({ data, handleRefresh }) => {
  const isFirstRender = useRef(true);
  const [isInitialRender, setIsInitialRender] = useState(true);

  const [textValue, setTextValue] = useState(data.comments);
  const [abilityValue, setAbility] = useState(data.ability);
  const [aspirationValue, setAspiration] = useState(data.aspiration);
  const [adaptabilityValue, setAdaptability] = useState(data.adaptability);
  const [readinessValue, setReadiness] = useState(data.readiness);
  const [isReadyValue, setIsReady] = useState(data.isPromoReady);
  const [performancerating, setPerformancerating] = useState(data.performancerating);
  const [isModified, setIsModified] = useState(false);
 const { idToken } = useAppContext();

  const { Option } = Select;

  const [successorData, setsuccessorData] = useState([
    {
      empName: '',
      empMailId: '',
      successorMailID: '',
      manager: '',
      title: '',
      readiness: '',
      comments: ''
    }
  ]);

 
  //console.log('Data:', data);

  message.config({
    className: 'ant-message-custom-content',
    duration: 3, // Adjust the duration as needed
  })

  useEffect(() => {

    //console.log('Use Effect Triggered');
    setIsInitialRender(true);
    //console.log('isInitialRender:', isInitialRender);
    setAbility(data.ability);
    setAspiration(data.aspiration);
    setAdaptability(data.adaptability);
    setReadiness(data.readiness);
    setTextValue(data.comments)
    setIsReady(data.isPromoReady);
    setPerformancerating(data.performancerating);
    setsuccessorData([])

    // Define the function to fetch data
    const fetchSuccessorData = async () => {
      try {
        const url = successorURL +'/GetSuccessors';
    const requestData = {
      userId: data.userPrincipalName
    };

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
      },
      body: JSON.stringify(requestData)
    });

    if (response.ok) {
      const data = await response.json();
      setsuccessorData(data); // Assuming the response is an array of successors
    } else {
      //console.error('Error fetching data:', response.status, response.statusText);
    }
      } catch (error) {
        //console.error('Error fetching data:', error);
      }
    };

    // Call the function to fetch data
    fetchSuccessorData();
    setIsInitialRender(false);
  }, [data]);

  const saveEmployeeData = async (potentialRating) => {
    const apiData = {
      userEmail: data.userEmail,
      userPrincipalName: data.userPrincipalName,
      potentialRating: potentialRating.toString(),
      performanceRating: performancerating,
      ability: abilityValue,
      aspiration: aspirationValue,
      adaptability: adaptabilityValue,
      readiness: readinessValue,
      comment: textValue,
      isPromoReady: isReadyValue,
      commentDate: new Date().toISOString()
    };
  
    //console.log('API Data:', apiData);
  
    try {
      const response = await fetch(employeesURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
           'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(apiData)
      });
  
      if (!response.ok) {
        throw new Error('Failed to save data');
      }
  
      const data = await response.json();
      //console.log('Data saved successfully:', data);
  
     
    message.success("Saved");

    //console.log('Calling handleRefresh');
    handleRefresh(); // Ensure refresh is called after save is successful
    } catch (error) {
      //console.error('Error saving data:', error);
      message.error('Failed to save data');
    }
  };
  

  const handlesave = async () => {

    //console.log('Handle Save called');
    if (!abilityValue || !aspirationValue || !adaptabilityValue || !readinessValue || !isReadyValue || !performancerating) {
      message.error('Please fill all required fields');
      return;
    }
    
    //console.log(readinessValue);
    //console.log(abilityValue);
    //console.log(aspirationValue);
    //console.log(adaptabilityValue);
    //console.log(parseFloat(abilityValue) + parseFloat(aspirationValue) + parseFloat(adaptabilityValue));
  
    const abilityFloatValue = parseFloat(abilityValue);
    const aspirationFloatValue = parseFloat(aspirationValue);
    const adaptabilityFloatValue = parseFloat(adaptabilityValue);
  
    // Calculate the average of the three values
    const averageRating = Math.ceil((abilityFloatValue + aspirationFloatValue + adaptabilityFloatValue) / 3);
    //console.log('Average Rating:', averageRating);
  
    await saveEmployeeData(averageRating);
    //console.log('Successor Data', successorData);
    
    if (successorData.length > 0) {
    try {
      //console.log('Executing API call for successor data:', successorData)
      const response = await fetch(successorURL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(successorData)
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const responseData = await response.json();
      //console.log('Success:', responseData);
      //console.log('Calling handleRefresh');
      handleRefresh(); // Refresh after successor data is saved
    } catch (error) {
      //console.error('Error:', error);
      //console.log('Calling handleRefresh on error');
      handleRefresh(); // Ensure refresh is called in case of error as well
    }
  } else {
    //console.log('No rows in successorData. Deleting all successors');
    try {
      const response = await fetch(successorURL + `/${data.userPrincipalName}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        }
      });

      if (response.status === 204) {
        //console.log('Resource deleted successfully.');
      } else if (response.ok) {
        //console.log('Resource deleted successfully.');
      } else {
        //console.log('Failed to delete the resource.');
      }
    } catch (error) {
      //console.log(`Error: ${error.message}`);
    }
  }
  };
  

  const handleTextareaChange = (e) => {
    setTextValue(e.target.value);
    setIsModified(prevFlag => !prevFlag);
  };

  const handleReadinessChange = (value) => {
    setReadiness(value);
    setIsModified(prevFlag => !prevFlag);
  }

  const handleIsReadyChange = (value) => {
    setIsReady(value);
    setIsModified(prevFlag => !prevFlag);
  }

  const handleAbilityChange = (value) => {
    //console.log('Chane Event', value)
    setAbility(value);
    setIsModified(prevFlag => !prevFlag);
  }

  const handleAspirationChange = (value) => {
    setAspiration(value);
    setIsModified(prevFlag => !prevFlag);
  }

  const handleAdaptabilityChange = (value) => {
    setAdaptability(value);
    setIsModified(prevFlag => !prevFlag);
  }

  const HandlePerformanceratingChange = (value) => {
    setPerformancerating(value);
    setIsModified(prevFlag => !prevFlag);
  }

  

  useEffect(() => {
    //console.log('Save called automatically');
    //console.log('Is Initial Render:', isInitialRender);
    //console.log('isFirstRender:', isFirstRender.current);
    // Skip initial render
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (isInitialRender) {
      return;
    }

    
    let saveTimeout;
    
    // Schedule save after 2 seconds (2000 milliseconds)
    saveTimeout = setTimeout(() => {
      handlesave();
    }, 10000);

    // Clean up function to clear timeout when component unmounts or adaptabilityValue changes
    return () => {
      clearTimeout(saveTimeout);
    };
  }, [isModified]);

  return (
    <Space>
      <div className="rootassessmentpage" style={{ margin: '10px' }} >
        <div style={{ alignItems: 'center', display: 'flex' }}>
          <Text style={{ fontSize: '25px', marginRight: '10px', fontWeight: 'bold' }}>
            Assessment
          </Text>
          <Text style={{ fontSize: '16px',marginRight:'10px' }}>
            | Overall Performance Rating -
          </Text>
          {/* <Text style={{ padding: '8px', borderRadius: '8px', fontSize: '16px', marginLeft: '10px', backgroundColor: '#F9E79F' }}>
            {data.performancerating}
          </Text> */}
          <Select value={performancerating} onChange={HandlePerformanceratingChange} style={{ width: '280px', fontSize: '10px' }} placeholder="Select an option" >
                <Option value="5">Always Exceeds Expectations</Option>
                <Option value="4">Meets and Often Exceeds Expectations</Option>
                <Option value="3">Consistently Meets Expectations</Option>
                <Option value="2">Partially Meets Expectations</Option>
                <Option value="1">Does Not Meet Expectations</Option>
              </Select>
              <Text style={{ fontSize: 12 }}></Text>
        </div>
        <div style={{ marginTop: '20px' }}>
          <EmployeeManagerDetail data={data} />
        </div>

        <div style={{ marginTop: '10px' }} className="9box">
          <Row gutter={[150, 150]}>

            <Col>
              <PotentialMetrices ability={abilityValue} aspiration={aspirationValue} adaptability={adaptabilityValue} onAbilityChange={handleAbilityChange} onAspirationChange={handleAspirationChange} onAdapatabilityChange={handleAdaptabilityChange} />
            </Col>
          </Row>
        </div>

        <div style={{ marginTop: '20px' }}>
          <PromotionMetrices data={data} value={textValue} onChange={handleTextareaChange} readiness={readinessValue} onReadinessChange={handleReadinessChange} isReady={isReadyValue} isReadyChange={handleIsReadyChange} />
        </div>

        <div style={{ marginTop: '20px' }}>
          <SuccessorComponent user={data} successorData={successorData} setsuccessorData={setsuccessorData} />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '15px' }}>

          <Button type="primary" onClick={handlesave}>Save</Button>
        </div>

      </div>
    </Space>
  );
};

export default AssessmentPage;